import { Toast } from 'patsnap-biz';
import psHttp, { psHttp$ } from '@patsnap/common-ps-http';
import { RouterService } from '@eureka/core-services/src/vue-router-service';
import { i18n } from '@/infrastructure/locales';
import { I18nService } from '@/services/i18n-service';
import router from '@/routes';
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { CheckSensitiveWordService, CheckSensitiveWordServiceImpl } from '@/services/common/check-sensitive-word';
import {
    HttpErrorHandlerContribution,
    ErrorHandlerContribution,
    ErrorHandlerRegistry,
    ErrorHandlerRegistryImpl,
    ErrorHandler,
    ErrorHandlerImpl,
    bindContributionProvider,
    Message,
    OpenService,
    OpenServiceImpl,
    PsHttp,
    PsHttp$,
    PsHttpChannel,
    PsHttpChannelImpl,
    Logger,
} from '@patsnap/tahiti-core';
import { AiDisclosureErrorHandler } from '@/infrastructure/error-handler/air-error-handle';

export const baseModule = new ContainerModule((bind) => {
    bind(I18nService).toConstantValue({
        t: i18n.global.t.bind(i18n),
        te: i18n.global.te.bind(i18n),
        locale: i18n.global.locale.value,
    });
    bindContributionProvider(bind, HttpErrorHandlerContribution);
    bind(Logger).toConstantValue(console);
    bind(PsHttp).toConstantValue(psHttp);
    bind(PsHttp$).toConstantValue(psHttp$);
    bind(PsHttpChannel).to(PsHttpChannelImpl);
    bind(Message).toConstantValue(Toast);
    bind(OpenService).to(OpenServiceImpl);
    bind(ErrorHandler).to(ErrorHandlerImpl);
    bind(ErrorHandlerRegistry).to(ErrorHandlerRegistryImpl);
    bindContributionProvider(bind, ErrorHandlerContribution);
    bind(RouterService).toConstantValue(router);
    bind(ErrorHandlerContribution).to(AiDisclosureErrorHandler);
    bind(CheckSensitiveWordService).to(CheckSensitiveWordServiceImpl);
});
